/**
 * The online order this browser tab went to pay for. The cart is kept until
 * that order is paid, so a failed payment can be retried, and it is cleared
 * only for that order (not when an old confirmation link is reopened later).
 */
const STORAGE_KEY = 'pendingOnlinePaymentOrder';

export function rememberPendingOnlinePayment(orderNumber) {
    try {
        if (orderNumber) sessionStorage.setItem(STORAGE_KEY, String(orderNumber));
    } catch {
        /* private mode / storage disabled */
    }
}

/** True once per order: when `orderNumber` is the order this tab was paying for. */
export function takePendingOnlinePayment(orderNumber) {
    try {
        if (!orderNumber || sessionStorage.getItem(STORAGE_KEY) !== String(orderNumber)) return false;
        sessionStorage.removeItem(STORAGE_KEY);
        return true;
    } catch {
        return false;
    }
}
